var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("box", {
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function() {
          return [
            _c("h4", [_vm._v(_vm._s(_vm.resource("IOFormat_OverView_Header")))])
          ]
        },
        proxy: true
      },
      {
        key: "body",
        fn: function() {
          return [
            _c("data-table", {
              staticClass: "table table-striped",
              attrs: {
                columns: _vm.columns,
                data: _vm.formats,
                loading: _vm.loading
              },
              on: {
                edit: function($event) {
                  return _vm.editIoFormat($event.id)
                },
                clone: function($event) {
                  _vm.formatToClone = $event.id
                },
                copyId: function($event) {
                  return _vm.copyToClipboard($event.id)
                }
              }
            }),
            _vm._v(" "),
            _vm.formatToClone
              ? _c("prompt", {
                  attrs: {
                    title: _vm.resource("IOFormat_OverView_Clone_Prompt_Title"),
                    body: _vm.resource("IOFormat_OverView_Clone_Prompt_Body"),
                    icon: "fas fa-clone"
                  },
                  on: {
                    yes: function($event) {
                      return _vm.cloneIoFormat(_vm.formatToClone)
                    },
                    no: function($event) {
                      _vm.formatToClone = null
                    }
                  }
                })
              : _vm._e()
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }